export function selectNewSliderSequence(state, payload) {
  return {
    ...state,
    currentSection: setSliderValueInCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function setSliderValueInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: setDropdownValueInComponents(
      currentSection.components,
      payload
    ),
  };
}

function setDropdownValueInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload.componentID) {
      component = setSliderValueInDNDQComponent(component, payload);
    }
    return component;
  });
}

function setSliderValueInDNDQComponent(DNDQComponent, payload) {
  const setValueInSlider = (slider) => {
    const updatedSlider = {...slider};
    if (updatedSlider.id === payload.sliderID) {
      updatedSlider.current = payload.current;
      updatedSlider.updated = true;
    }
    return updatedSlider;
  };

  return {
    ...DNDQComponent,
    showFeedback: false,
    sliders: DNDQComponent.sliders.map(setValueInSlider),
  };
}
